import React, { useState } from 'react';
import './EmailLogsAccordionRow.css';
import { formatDate } from '../../../helpers/DateFormatter';
import { EmailLogProps } from '../../../interfaces/IEmailLogs';

const EmailLogAccordionRow: React.FC<EmailLogProps> = ({ log }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <tr
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
        className={isOpen ? 'table-active' : 'table-collapsed'}
      >
        <td>{formatDate(log.timestamp)}</td>
        <td>{log.subject}</td>
        <td>
          {log.taskNames && log.taskNames.length > 0 && (
            <div>
              <strong>Task:</strong> {log.taskNames.join(', ')}
            </div>
          )}
          {log.fileNames && log.fileNames.length > 0 && (
            <div>
              <strong>File:</strong> {log.fileNames.join(', ')}
            </div>
          )}
        </td>

        <td>
          <div className="d-flex align-items-center justify-content-center">
            <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
          </div>
        </td>
      </tr>
      {isOpen && (
        <tr>
          <td colSpan={5}>
            <div className="p-3 accordion-content">
              <div className="card">
                <div className="card-body">
                  <div className="card-subtitle mb-3 text-muted">
                    <small className="text-muted">
                      <strong>Recipients:</strong>
                      <br />
                    </small>
                    <div className='emailRecipientList'>
                      {log.emailAddresses && log.emailAddresses.length > 0 ? (
                        <small>
                          {log.emailAddresses.join(", ")}
                        </small>
                      ) : (
                        <p>No recipients</p>
                      )}
                    </div>

                    <br />
                    <br />
                    <small className="text-muted">
                      <strong>Subject:</strong>
                      <br />
                    </small>
                    <h6>{log.subject}</h6>
                  </div>
                    <div className="mt-3 emailMessageBody">
                      <small className="text-muted">
                        <strong>Message:</strong>
                        <br />
                      </small>
                      {log.message}
                    </div>
                  </div>
                </div>
              </div>
          </td >
        </tr >
      )}
    </>
  );
};

export default EmailLogAccordionRow;
